export const maxAllowedItemsInOrder = 999;
